import React from "react";
import PropTypes from "prop-types";

import "./section-header.styles.scss";

const SectionHeader = (props) => {
  const { main, headerText } = props;

  return (
    <div className="section-header">
      <span className="section-header_agency">{main}</span>

      <h1 className="section-header_h1">{headerText}</h1>
    </div>
  );
};

SectionHeader.propTypes = {
  main: PropTypes.string,
  headerText: PropTypes.string,
};

export default SectionHeader;
